import Base, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './base'

const KEY = 'user.promotions'
const PATH = '/customer/user/promotion'

const myServices = {}

export const claim = myServices.claim = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.claim`, payload, `${PATH}/{id}/apply`, options)
  const {data = {}} = await axios.post(endPoint, omitId(payload))
  return data.data || {}
}
setPromise(`${KEY}.claim`, claim)

export const all = myServices.all = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.get`, payload, `${PATH}`, options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return data.data || {}
}
setPromise(`${KEY}.get`, all)

export default {
  ...Base,
  ...myServices
}
